import { render, staticRenderFns } from "./Rategrid.vue?vue&type=template&id=028d3814&"
import script from "./Rategrid.vue?vue&type=script&lang=js&"
export * from "./Rategrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports